import { createContext, useContext } from 'react';

/**
 * What item renderers draw into. A normal screen's stage is the viewport; a video wall tile's
 * stage is the whole wall canvas (in canvas pixels), of which the tile shows its slice.
 *
 * - `vh(n)` / `vw(n)`: n% of the stage's height / width as a CSS length
 * - `fitClass`: how media fits the stage (object-contain / -cover / -fill)
 * - `wall`: the bundle's wall placement, or null on a normal screen
 * - `now()`: the shared clock (server-synced on walls)
 */
const VIEWPORT_STAGE = {
  vh: (n) => `${n}vh`,
  vw: (n) => `${n}vw`,
  fitClass: 'object-contain',
  wall: null,
  now: () => Date.now(),
};

const StageContext = createContext(VIEWPORT_STAGE);

export const StageProvider = StageContext.Provider;

export const useStage = () => useContext(StageContext);
